module.exports = __webpack_public_path__ + "media/cp6.3ed835a2.mp4";